export default {
  alternativeController: {
    id: 'product_page_carousel_alternative_controller',
    defaultMessage: 'Controller',
  },
  alternativeNext: {
    id: 'product_page_carousel_alternative_next',
    defaultMessage: 'Next',
  },
  alternativePrevious: {
    id: 'product_page_carousel_alternative_previous',
    defaultMessage: 'Previous',
  },
  alternativeClose: {
    id: 'product_page_carousel_alternative_close',
    defaultMessage: 'Close',
  },
  carouselAriaLabel: {
    id: 'product_page_carousel_aria_label',
    defaultMessage: '{productName} stock photo image gallery',
  },
  mainImageButtonAriaLabel: {
    id: 'product_page_carousel_main_image_button_aria_label',
    defaultMessage: 'Stock photo of {productName}',
  },
  thumbnailButtonAriaLabel: {
    id: 'product_page_carousel_thumbnail_button_aria_label',
    defaultMessage: 'Stock photo of {productName}, image {current} of {total}',
  },
  videoThumbnailButtonAriaLabel: {
    id: 'product_page_carousel_video_thumbnail_button_aria_label',
    defaultMessage: 'Video of {productName}',
  },
  reviewButtonAriaLabel: {
    id: 'product_page_carousel_review_button_aria_label',
    defaultMessage: 'Customer review photo for {productName}',
  },
  reviewThumbnailButtonAriaLabel: {
    id: 'product_page_carousel_review_thumbnail_button_aria_label',
    defaultMessage: 'Customer review photo of {productName}',
  },
  jpRefurbishmentInfographicAlt: {
    id: 'product_page_carousel_jp_refurbishment_infographic_alt',
    defaultMessage:
      'An illustration showing the refurbishment inspection and quality-check process. It outlines the seven-step process: visual inspection, disassembly and cleaning, data erasure, software diagnostics, parts replacement, battery checks, and functional testing.',
  },
}
